import RedeemQRPage from './RedeemQRPage';

export default RedeemQRPage;
